import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Servicios',
    path: '/servicios'
  }, {
    name: 'Historia',
    path: '/historia'
  }, {
    name: 'Proyectos',
    path: '/proyectos'
  }, {
    name: 'Testimonios',
    path: '/testimonios'
  }, {
    name: 'Ask ORION',
    path: '/ask-orion'
  }, {
    name: 'Legado Creativo',
    path: '/slideshow'
  }, {
    name: 'Estrategia',
    path: '/strategy'
  }, {
    name: 'Contacto',
    path: '/contacto'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-gray-900/95 backdrop-blur-md shadow-lg shadow-purple-500/20 py-2' : 'bg-transparent py-4'}`} data-id="element-89">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-90">
        <Link to="/" className="flex items-center" data-id="element-91">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="Grupo Reflex Logo" className="h-10 md:h-12 brightness-0 invert" data-id="element-92" />
        </Link>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-93">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors relative group ${location.pathname === link.path ? 'text-purple-400' : 'text-white hover:text-purple-400'}`} data-id="element-94">
              {link.name}
              <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 transform origin-left transition-transform ${location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-95"></span>
            </Link>)}
        </div>
        {/* Mobile Navigation Toggle */}
        <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white focus:outline-none" aria-label="Toggle menu" data-id="element-96">
          {isOpen ? <XIcon className="h-6 w-6" data-id="element-97" /> : <MenuIcon className="h-6 w-6" data-id="element-98" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isOpen && <div className="md:hidden bg-gray-900/95 backdrop-blur-md shadow-lg" data-id="element-99">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-100">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium block py-2 transition-colors ${location.pathname === link.path ? 'text-purple-400' : 'text-white hover:text-purple-400'}`} data-id="element-101">
                {link.name}
              </Link>)}
          </div>
        </div>}
    </nav>;
};
export default Navbar;